export class PlayerRegistrationErrorCodes {
    static fieldErrorCode = 'PI0224';
    static invalidAccountNumberErrorCode = 'PI0150';
    static duplicatePlayerErrorCode = 'PI0920';
    static DUPLICATION_USER_ERROR = 'DUPLICATION_USER_ERROR';
    static DUPLICATE_ACCOUNT_NUMBER = 'DUPLICATE_ACCOUNT_NUMBER';
}